import React from "react";

interface IconProps {
  color?: string;
  size?: number;
}

interface IconColorProps {
  color: string;
}

interface IconLogoWithTextProps {
  logoColor: string;
  textColor: string;
}

/**
 *
 * @param param0 color and size
 * @returns ArrowRight icon
 */
const ArrowRight: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.675 11.115L14.53 4.97L13.47 6.03L18.69 11.25H3V12.75H18.69L13.47 17.97L14.53 19.03L20.675 12.885C21.16 12.4 21.16 11.605 20.675 11.115Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns  ArrowLeft icon
 */
const ArrowLeft: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="arrow-left">
      <path
        id="Vector"
        d="M21.0002 11.25H5.31018L10.5302 6.03L9.47018 4.97L3.32518 11.115C2.84018 11.6 2.84018 12.395 3.32518 12.885L9.47018 19.03L10.5302 17.97L5.31018 12.75H21.0002V11.25Z"
        fill={color}
      />
    </g>
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns ArrowCircleRight icon
 */
const ArrowCircleRight: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.485 6.485 2 12 2C17.515 2 22 6.485 22 12C22 17.515 17.515 22 12 22C6.485 22 2 17.515 2 12ZM3.5 12C3.5 16.685 7.315 20.5 12 20.5C16.685 20.5 20.5 16.685 20.5 12C20.5 7.315 16.685 3.5 12 3.5C7.315 3.5 3.5 7.315 3.5 12ZM11.97 9.02997L13.03 7.96997L16.175 11.115C16.66 11.605 16.66 12.4 16.175 12.885L13.03 16.03L11.97 14.97L14.19 12.75H7.5V11.25H14.19L11.97 9.02997Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns ArrowCircleLeft icon
 */
const ArrowCircleLeft: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.485 6.485 2 12 2C17.515 2 22 6.485 22 12C22 17.515 17.515 22 12 22C6.485 22 2 17.515 2 12ZM3.5 12C3.5 16.685 7.315 20.5 12 20.5C16.685 20.5 20.5 16.685 20.5 12C20.5 7.315 16.685 3.5 12 3.5C7.315 3.5 3.5 7.315 3.5 12ZM10.9701 7.96997L12.0301 9.02997L9.81005 11.25H16.5001V12.75H9.81005L12.0301 14.97L10.9701 16.03L7.82505 12.885C7.34005 12.395 7.34005 11.6 7.82505 11.115L10.9701 7.96997Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns ExclamationCircle icon
 */
const ExclamationCircle: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
      fill={color}
    />
    <path
      d="M12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12 8V13.5"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Delete icon
 */
const Delete: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 2.91675H9.33333V2.77091C9.33333 1.88716 8.61292 1.16675 7.72917 1.16675H6.27083C5.38708 1.16675 4.66667 1.88716 4.66667 2.77091V2.91675H1.75V3.79175H2.33333V11.2292C2.33333 12.113 3.05375 12.8334 3.9375 12.8334H10.0625C10.9462 12.8334 11.6667 12.113 11.6667 11.2292V3.79175H12.25V2.91675ZM5.54167 2.77091C5.54167 2.36841 5.86833 2.04175 6.27083 2.04175H7.72917C8.13167 2.04175 8.45833 2.36841 8.45833 2.77091V2.91675H5.54167V2.77091ZM10.7917 11.2292C10.7917 11.6317 10.465 11.9584 10.0625 11.9584H3.9375C3.535 11.9584 3.20833 11.6317 3.20833 11.2292V3.79175H10.7917V11.2292ZM6.125 5.54175H5.25V10.2084H6.125V5.54175ZM7.875 5.54175H8.75V10.2084H7.875V5.54175Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Warning icon
 */
const Warning: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.42508 19.5L11.5651 3.51001C11.7551 3.17501 12.2401 3.17501 12.4351 3.51001L21.5751 19.5C21.7651 19.835 21.5251 20.25 21.1401 20.25H2.86008C2.47508 20.25 2.23508 19.835 2.42508 19.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z"
      fill={color}
    />
    <path
      d="M12 9V14.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns ArrowBoxRight icon
 */
const ArrowBoxRight: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 16L13.9198 12.1881C14.0267 12.084 14.0267 11.916 13.9198 11.8119L10 8"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M18.5 4H6C4.89543 4 4 4.89543 4 6V18.5C4 19.6046 4.89543 20.5 6 20.5H18.5C19.6046 20.5 20.5 19.6046 20.5 18.5V6C20.5 4.89543 19.6046 4 18.5 4Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Locked icon
 */
const Locked: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 11.25V8C6.75 5.1 9.1 2.75 12 2.75C14.9 2.75 17.25 5.1 17.25 8V11.25"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M17.25 11.25H6.75C5.64543 11.25 4.75 12.1454 4.75 13.25V19.25C4.75 20.3546 5.64543 21.25 6.75 21.25H17.25C18.3546 21.25 19.25 20.3546 19.25 19.25V13.25C19.25 12.1454 18.3546 11.25 17.25 11.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Unlocked icon
 */
const Unlocked: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 11.255V8.005C6.75 5.105 9.1 2.755 12 2.755C14.175 2.755 16.04 4.08 16.835 5.965"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M17.25 11.25H6.75C5.64543 11.25 4.75 12.1454 4.75 13.25V19.25C4.75 20.3546 5.64543 21.25 6.75 21.25H17.25C18.3546 21.25 19.25 20.3546 19.25 19.25V13.25C19.25 12.1454 18.3546 11.25 17.25 11.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns DragIndicator icon
 */
const DragIndicator: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.6747 11.115L19.0297 8.46999L17.9697 9.52999L19.6897 11.25H12.7497V4.30999L14.4697 6.02999L15.5297 4.96999L12.8847 2.32499C12.3997 1.83999 11.6047 1.83999 11.1147 2.32499L8.46969 4.96999L9.52969 6.02999L11.2497 4.30999V11.25H4.30969L6.02969 9.52999L4.96969 8.46999L2.32469 11.115C1.83969 11.6 1.83969 12.395 2.32469 12.885L4.96969 15.53L6.02969 14.47L4.30969 12.75H11.2497V19.69L9.52969 17.97L8.46969 19.03L11.1147 21.675C11.3597 21.92 11.6797 22.04 11.9997 22.04C12.3197 22.04 12.6397 21.92 12.8847 21.675L15.5297 19.03L14.4697 17.97L12.7497 19.69V12.75H19.6897L17.9697 14.47L19.0297 15.53L21.6747 12.885C22.1597 12.4 22.1597 11.605 21.6747 11.115Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Checkmark icon
 */
const Checkmark: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 6.245L9.105 17.39C8.91 17.585 8.595 17.585 8.4 17.39L3.75 12.745"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Undo icon
 */
const Undo: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 7.75H15C17.9 7.75 20.25 10.1 20.25 13C20.25 15.9 17.9 18.25 15 18.25H7"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M7.50023 3.5L3.60523 7.395C3.41023 7.59 3.41023 7.905 3.60523 8.1L7.50023 11.995"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Plus icon
 */
const Plus: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 4V20" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M20 12H4" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Star Outlined icon
 */
const StarOutlined: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9948 14.3749L18.0048 20.2499C18.0748 20.6599 17.6448 20.9699 17.2798 20.7749L12.0048 17.9999L6.72983 20.7749C6.36483 20.9699 5.93483 20.6549 6.00483 20.2499L7.01483 14.3749L2.73483 10.2149C2.43983 9.92495 2.59983 9.41995 3.00983 9.35995L8.90983 8.50495L11.5498 3.15995C11.7348 2.78995 12.2648 2.78995 12.4448 3.15995L15.0848 8.50495L20.9848 9.35995C21.3948 9.41995 21.5598 9.92495 21.2598 10.2149L16.9948 14.3749Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Star Filled icon
 */
const StarFilled: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9948 14.3749L18.0048 20.2499C18.0748 20.6599 17.6448 20.9699 17.2798 20.7749L12.0048 17.9999L6.72983 20.7749C6.36483 20.9699 5.93483 20.6549 6.00483 20.2499L7.01483 14.3749L2.73483 10.2149C2.43983 9.92495 2.59983 9.41995 3.00983 9.35995L8.90983 8.50495L11.5498 3.15995C11.7348 2.78995 12.2648 2.78995 12.4448 3.15995L15.0848 8.50495L20.9848 9.35995C21.3948 9.41995 21.5598 9.92495 21.2598 10.2149L16.9948 14.3749Z"
      fill={color}
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Close icon
 */
const Close: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.75 4.25L4.25 19.75"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M4.25 4.25L19.75 19.75"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns InfoCircle icon
 */
const InfoCircle: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path d="M12.75 16V10.5H11.25V16H12.75Z" fill={color} />
    <path
      d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns QuestionCircle icon
 */
const QuestionCircle: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M9.375 9.015C9.805 7.98 10.825 7.25 12.015 7.25C13.59 7.25 14.87 8.53 14.87 10.105C14.87 12.75 12 12.25 12 14.5V15"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12 18.5C12.5523 18.5 13 18.0523 13 17.5C13 16.9477 12.5523 16.5 12 16.5C11.4477 16.5 11 16.9477 11 17.5C11 18.0523 11.4477 18.5 12 18.5Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns PlusCircle icon
 */
const PlusCircle: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12 7.5V16.5"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M16.5 12H7.5"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Edit icon
 */
const Edit: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.555 3.555L16.0247 3.02467L16.555 3.555ZM3.555 16.555L3.02467 16.0247L2.85608 16.1933L2.81579 16.4283L3.555 16.555ZM2.75 21.25L2.01079 21.1233C1.96965 21.3632 2.04753 21.6082 2.21967 21.7803C2.39181 21.9525 2.6368 22.0304 2.87674 21.9892L2.75 21.25ZM7.445 20.445L7.57174 21.1842L7.80674 21.1439L7.97533 20.9753L7.445 20.445ZM20.445 7.445L20.9753 7.97533L20.445 7.445ZM16.0247 3.02467L3.02467 16.0247L4.08533 17.0853L17.0853 4.08533L16.0247 3.02467ZM2.81579 16.4283L2.01079 21.1233L3.48921 21.3767L4.29421 16.6817L2.81579 16.4283ZM2.87674 21.9892L7.57174 21.1842L7.31826 19.7058L2.62326 20.5108L2.87674 21.9892ZM7.97533 20.9753L20.9753 7.97533L19.9147 6.91467L6.91467 19.9147L7.97533 20.9753ZM20.9753 7.97533C22.3432 6.60744 22.3432 4.39256 20.9753 3.02467L19.9147 4.08533C20.6968 4.86744 20.6968 6.13256 19.9147 6.91467L20.9753 7.97533ZM20.9753 3.02467C19.6074 1.65678 17.3926 1.65678 16.0247 3.02467L17.0853 4.08533C17.8674 3.30322 19.1326 3.30322 19.9147 4.08533L20.9753 3.02467Z"
      fill={color}
    />
    <path
      d="M13.75 6.75L17.25 10.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns CircleCheck icon
 */
const CircleCheck: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M16.75 8.745L10.855 14.64C10.66 14.835 10.345 14.835 10.15 14.64L7.755 12.245"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Clip icon
 */
const Clip: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7505 11.75L20.0005 10.5C21.7955 8.705 21.7955 5.795 20.0005 4C18.2055 2.205 15.2955 2.205 13.5005 4L4.00055 13.5C2.20555 15.295 2.20555 18.205 4.00055 20C5.79555 21.795 8.70555 21.795 10.5005 20L15.2505 15.25C16.3555 14.145 16.3555 12.355 15.2505 11.25C14.1455 10.145 12.3555 10.145 11.2505 11.25L6.25055 16.25"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Menu icon
 */
const Menu: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6.25H21"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path d="M3 12H21" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" />
    <path
      d="M3 17.75H21"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Globe icon
 */
const Globe: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M2.75 12H21.25"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12 2.75C12 2.75 7.75 6 7.75 12"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12 21.25C12 21.25 7.75 18 7.75 12"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12 2.75C12 2.75 16.25 6 16.25 12"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M12 21.25C12 21.25 16.25 18 16.25 12"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M5.08496 5.84998C6.64996 6.79498 8.97496 7.74998 12 7.74998C15.025 7.74998 17.355 6.79498 18.915 5.84998"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M18.915 18.15C17.35 17.205 15.025 16.25 12 16.25C8.97496 16.25 6.64496 17.205 5.08496 18.15"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns User icon
 */
const User: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.25C14.6234 12.25 16.75 10.1234 16.75 7.5C16.75 4.87665 14.6234 2.75 12 2.75C9.37665 2.75 7.25 4.87665 7.25 7.5C7.25 10.1234 9.37665 12.25 12 12.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M3.69141 22L4.70641 18.215C5.17641 16.465 6.76141 15.25 8.57141 15.25H15.4314C17.2414 15.25 18.8264 16.465 19.2964 18.215L20.3114 22"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns WifiOff icon
 */
const WifiOff: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 20.5C12.8284 20.5 13.5 19.8284 13.5 19C13.5 18.1716 12.8284 17.5 12 17.5C11.1716 17.5 10.5 18.1716 10.5 19C10.5 19.8284 11.1716 20.5 12 20.5Z"
      fill={color}
    />
    <path
      d="M8.29004 15.29C9.24004 14.34 10.555 13.75 12 13.75"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M5.10547 12.105C6.87047 10.34 9.30547 9.25 12.0005 9.25C14.6955 9.25 17.1305 10.34 18.8955 12.105"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M1.9248 8.925C4.5048 6.345 8.0648 4.75 11.9998 4.75C15.9348 4.75 19.4998 6.345 22.0748 8.925"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M3.75 3.75L20.25 20.25"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M2.69043 4.81L19.1904 21.31"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns ChevronRight icon
 */
const ChevronLeft: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7502 18.25L8.85523 12.355C8.66023 12.16 8.66023 11.845 8.85523 11.65L14.7502 5.755"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color
 * @returns ItemPathLogo
 */
const ItemPathLogo: React.FC<IconColorProps> = ({ color }) => (
  <svg
    width="61"
    height="65"
    viewBox="0 0 61 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.9989 15.6295C34.547 15.6295 38.2339 12.1307 38.2339 7.81475C38.2339 3.49878 34.547 0 29.9989 0C25.4509 0 21.7639 3.49878 21.7639 7.81475C21.7639 12.1307 25.4509 15.6295 29.9989 15.6295Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.2504 18.6597V28.8982C49.544 28.8022 48.8219 28.7525 48.0876 28.7525C39.7267 28.7525 32.9488 35.1916 32.9488 43.1347C32.9488 46.6978 34.3127 49.9582 36.5715 52.4706H23.3788C25.6376 49.9582 27.0014 46.6978 27.0014 43.1347C27.0014 35.1916 20.2236 28.7525 11.8627 28.7525C10.9399 28.7525 10.0365 28.8309 9.1593 28.9811V18.6597H16.3897C18.7379 23.7123 24.0582 27.2386 30.2455 27.2386C36.4328 27.2386 41.7531 23.7123 44.1012 18.6597H50.2504Z"
      fill={color}
    />
    <path
      d="M52.015 52.1515C56.5631 52.1515 60.25 48.6527 60.25 44.3367C60.25 40.0208 56.5631 36.522 52.015 36.522C47.467 36.522 43.78 40.0208 43.78 44.3367C43.78 48.6527 47.467 52.1515 52.015 52.1515Z"
      fill={color}
    />
    <path
      d="M8.23501 52.1515C12.7831 52.1515 16.47 48.6527 16.47 44.3367C16.47 40.0208 12.7831 36.522 8.23501 36.522C3.68694 36.522 0 40.0208 0 44.3367C0 48.6527 3.68694 52.1515 8.23501 52.1515Z"
      fill={color}
    />
    <path
      d="M8.65517 29.0262C13.2032 29.0262 16.8902 25.5274 16.8902 21.2114C16.8902 16.8955 13.2032 13.3967 8.65517 13.3967C4.1071 13.3967 0.420166 16.8955 0.420166 21.2114C0.420166 25.5274 4.1071 29.0262 8.65517 29.0262Z"
      fill={color}
    />
    <path
      d="M51.8469 29.0262C56.395 29.0262 60.082 25.5274 60.082 21.2114C60.082 16.8955 56.395 13.3967 51.8469 13.3967C47.2989 13.3967 43.6119 16.8955 43.6119 21.2114C43.6119 25.5274 47.2989 29.0262 51.8469 29.0262Z"
      fill={color}
    />
    <path
      d="M29.9989 64.99C34.547 64.99 38.2339 61.4912 38.2339 57.1753C38.2339 52.8593 34.547 49.3605 29.9989 49.3605C25.4509 49.3605 21.7639 52.8593 21.7639 57.1753C21.7639 61.4912 25.4509 64.99 29.9989 64.99Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 color
 * @returns ItemPath Text
 */
const ItemPathText: React.FC<IconColorProps> = ({ color }) => (
  <svg
    width="246"
    height="43"
    viewBox="0 0 246 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M222.054 25.9643V42.4714H215.176V0H222.054V17.5388C223.037 15.6665 224.521 14.1954 226.507 13.1255C228.493 12.0555 230.632 11.5206 232.925 11.5206C236.61 11.5206 239.589 12.5714 241.861 14.673C244.134 16.7746 245.27 19.8124 245.27 23.7863V42.4714H238.391V25.7351C238.391 20.118 235.894 17.3095 230.898 17.3095C228.524 17.3095 226.456 18.0451 224.695 19.5162C222.935 20.9873 222.054 23.1367 222.054 25.9643ZM7.24724 42.4715V2.40734H0V42.4715H7.24724ZM25.4268 42.93C28.3543 42.93 31.026 41.9174 33.4417 39.8923L30.6166 35.3643C29.2654 36.7016 27.8528 37.3703 26.3788 37.3703C24.9047 37.3703 23.7583 36.9405 22.9394 36.0807C22.1205 35.221 21.711 34.0651 21.711 32.6131V17.1376H30.3095V11.9792H21.711V2.40734H14.8323V11.9792H10.7173V17.1376H14.8323V32.4411C14.8323 35.6508 15.8662 38.2014 17.9339 40.0929C20.0016 41.9843 22.4992 42.93 25.4268 42.93ZM62.6456 37.8288C59.1244 41.2295 54.5385 42.9299 48.8881 42.9299C44.3023 42.9299 40.4023 41.5066 37.1881 38.6599C33.974 35.8131 32.3669 31.992 32.3669 27.1966C32.3669 22.4011 34.0047 18.5896 37.2803 15.762C40.5559 12.9344 44.4149 11.5206 48.8574 11.5206C53.3 11.5206 57.0771 12.772 60.1889 15.2748C63.3007 17.7776 64.8566 21.2261 64.8566 25.6204V30.0337H39.2456C39.4094 32.25 40.4944 34.0363 42.5007 35.3928C44.507 36.7493 46.8 37.4276 49.3795 37.4276C53.474 37.4276 56.5858 36.2239 58.7149 33.8166L62.6456 37.8288ZM57.9779 24.99H39.2456C39.2456 22.5445 40.2488 20.6052 42.2551 19.1723C44.2614 17.7394 46.5236 17.023 49.0417 17.023C51.5598 17.023 53.6787 17.7108 55.3984 19.0864C57.1181 20.462 57.9779 22.4298 57.9779 24.99ZM74.837 25.9643V42.4714H67.9582V11.9791H74.837V17.5388C75.8196 15.6664 77.3039 14.1953 79.2897 13.1254C81.2756 12.0555 83.4149 11.5206 85.7078 11.5206C90.8669 11.5206 94.3677 13.5075 96.2102 17.4815C99.4448 13.5075 103.478 11.5206 108.309 11.5206C111.994 11.5206 114.973 12.5714 117.246 14.673C119.518 16.7746 120.654 19.8123 120.654 23.7863V42.4714H113.776V25.735C113.776 20.118 111.278 17.3095 106.283 17.3095C103.949 17.3095 101.912 18.0069 100.172 19.4016C98.4315 20.7963 97.5204 22.831 97.4385 25.5057V42.4714H90.5598V25.735C90.5598 22.831 90.007 20.7007 88.9015 19.3442C87.796 17.9878 86.0559 17.3095 83.6811 17.3095C81.3063 17.3095 79.2385 18.0451 77.4779 19.5162C75.7173 20.9873 74.837 23.1367 74.837 25.9643ZM134.013 42.4715V30.7216H141.628C147.934 30.7216 152.612 29.5944 155.662 27.34C158.713 25.0855 160.238 21.5319 160.238 16.6791C160.238 11.8263 158.743 8.23451 155.754 5.90364C152.765 3.57278 148.016 2.40734 141.506 2.40734H126.765V42.4715H134.013ZM134.013 24.5887H142.427C146.439 24.5887 149.172 23.8722 150.626 22.4393C152.08 21.0064 152.806 18.9048 152.806 16.1345C152.806 13.3642 151.885 11.4059 150.042 10.2596C148.2 9.11328 145.313 8.54012 141.383 8.54012H134.013V24.5887ZM172.061 42.9299C176.605 42.9299 180.229 41.4206 182.931 38.4019V42.4714H189.196V22.8119C189.196 18.9144 187.978 16.0581 185.542 14.2431C183.105 12.4281 179.963 11.5206 176.114 11.5206C171.078 11.5206 166.574 12.9917 162.602 15.9339L165.673 19.9461C168.949 17.8827 172.102 16.851 175.131 16.851C179.963 16.851 182.379 18.8762 182.379 22.9265V24.0728H173.473C169.42 24.0728 166.205 24.8179 163.831 26.3082C161.456 27.7984 160.268 30.0433 160.268 33.0428C160.268 36.0424 161.384 38.4401 163.616 40.2361C165.847 42.032 168.662 42.9299 172.061 42.9299ZM168.99 36.3099C170.218 37.0932 171.928 37.4849 174.118 37.4849C176.309 37.4849 178.223 36.9117 179.861 35.7654C181.498 34.6191 182.317 33.0715 182.317 31.1228V28.5435H174.579C169.624 28.5435 167.147 29.9955 167.147 32.8996C167.147 34.3898 167.761 35.5266 168.99 36.3099ZM206.147 42.93C209.075 42.93 211.746 41.9174 214.162 39.8923L211.337 35.3643C209.986 36.7016 208.573 37.3703 207.099 37.3703C205.625 37.3703 204.479 36.9405 203.66 36.0807C202.841 35.221 202.431 34.0651 202.431 32.6131V17.1376H211.03V11.9792H202.431V2.40734H195.553V11.9792H191.438V17.1376H195.553V32.4411C195.553 35.6508 196.587 38.2014 198.654 40.0929C200.722 41.9843 203.22 42.93 206.147 42.93Z"
      fill={color}
    />
  </svg>
);

/**
 *
 * @param param0 logoColor, textColor
 * @returns ItemPathLogoWithText
 */
const ItemPathLogoWithText: React.FC<IconLogoWithTextProps> = ({
  logoColor,
  textColor,
}) => (
  <svg
    width="320"
    height="65"
    viewBox="0 0 320 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.9989 15.6295C34.547 15.6295 38.2339 12.1307 38.2339 7.81475C38.2339 3.49878 34.547 0 29.9989 0C25.4509 0 21.7639 3.49878 21.7639 7.81475C21.7639 12.1307 25.4509 15.6295 29.9989 15.6295Z"
      fill={logoColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.2504 18.6597V28.8982C49.544 28.8022 48.8219 28.7525 48.0876 28.7525C39.7267 28.7525 32.9488 35.1916 32.9488 43.1347C32.9488 46.6978 34.3127 49.9582 36.5715 52.4706H23.3788C25.6376 49.9582 27.0014 46.6978 27.0014 43.1347C27.0014 35.1916 20.2236 28.7525 11.8627 28.7525C10.9399 28.7525 10.0365 28.8309 9.1593 28.9811V18.6597H16.3897C18.7379 23.7123 24.0582 27.2386 30.2455 27.2386C36.4328 27.2386 41.7531 23.7123 44.1012 18.6597H50.2504Z"
      fill={logoColor}
    />
    <path
      d="M52.015 52.1515C56.5631 52.1515 60.25 48.6527 60.25 44.3367C60.25 40.0208 56.5631 36.522 52.015 36.522C47.467 36.522 43.78 40.0208 43.78 44.3367C43.78 48.6527 47.467 52.1515 52.015 52.1515Z"
      fill={logoColor}
    />
    <path
      d="M8.23501 52.1515C12.7831 52.1515 16.47 48.6527 16.47 44.3367C16.47 40.0208 12.7831 36.522 8.23501 36.522C3.68694 36.522 0 40.0208 0 44.3367C0 48.6527 3.68694 52.1515 8.23501 52.1515Z"
      fill={logoColor}
    />
    <path
      d="M8.65517 29.0262C13.2032 29.0262 16.8902 25.5274 16.8902 21.2114C16.8902 16.8955 13.2032 13.3967 8.65517 13.3967C4.1071 13.3967 0.420166 16.8955 0.420166 21.2114C0.420166 25.5274 4.1071 29.0262 8.65517 29.0262Z"
      fill={logoColor}
    />
    <path
      d="M51.8469 29.0262C56.395 29.0262 60.082 25.5274 60.082 21.2114C60.082 16.8955 56.395 13.3967 51.8469 13.3967C47.2989 13.3967 43.6119 16.8955 43.6119 21.2114C43.6119 25.5274 47.2989 29.0262 51.8469 29.0262Z"
      fill={logoColor}
    />
    <path
      d="M29.9989 64.99C34.547 64.99 38.2339 61.4912 38.2339 57.1753C38.2339 52.8593 34.547 49.3605 29.9989 49.3605C25.4509 49.3605 21.7639 52.8593 21.7639 57.1753C21.7639 61.4912 25.4509 64.99 29.9989 64.99Z"
      fill={logoColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M296.054 36.9643V53.4714H289.176V11H296.054V28.5388C297.037 26.6665 298.521 25.1954 300.507 24.1255C302.493 23.0555 304.632 22.5206 306.925 22.5206C310.61 22.5206 313.589 23.5714 315.861 25.673C318.134 27.7746 319.27 30.8124 319.27 34.7863V53.4714H312.391V36.7351C312.391 31.118 309.894 28.3095 304.898 28.3095C302.524 28.3095 300.456 29.0451 298.695 30.5162C296.935 31.9873 296.054 34.1367 296.054 36.9643ZM81.2472 53.4715V13.4073H74V53.4715H81.2472ZM99.4268 53.93C102.354 53.93 105.026 52.9174 107.442 50.8923L104.617 46.3643C103.265 47.7016 101.853 48.3703 100.379 48.3703C98.9047 48.3703 97.7583 47.9405 96.9394 47.0807C96.1205 46.221 95.711 45.0651 95.711 43.6131V28.1376H104.309V22.9792H95.711V13.4073H88.8323V22.9792H84.7173V28.1376H88.8323V43.4411C88.8323 46.6508 89.8662 49.2014 91.9339 51.0929C94.0016 52.9843 96.4992 53.93 99.4268 53.93ZM136.646 48.8288C133.124 52.2295 128.539 53.9299 122.888 53.9299C118.302 53.9299 114.402 52.5066 111.188 49.6599C107.974 46.8131 106.367 42.992 106.367 38.1966C106.367 33.4011 108.005 29.5896 111.28 26.762C114.556 23.9344 118.415 22.5206 122.857 22.5206C127.3 22.5206 131.077 23.772 134.189 26.2748C137.301 28.7776 138.857 32.2261 138.857 36.6204V41.0337H113.246C113.409 43.25 114.494 45.0363 116.501 46.3928C118.507 47.7493 120.8 48.4276 123.379 48.4276C127.474 48.4276 130.586 47.2239 132.715 44.8166L136.646 48.8288ZM131.978 35.99H113.246C113.246 33.5445 114.249 31.6052 116.255 30.1723C118.261 28.7394 120.524 28.023 123.042 28.023C125.56 28.023 127.679 28.7108 129.398 30.0864C131.118 31.462 131.978 33.4298 131.978 35.99ZM148.837 36.9643V53.4714H141.958V22.9791H148.837V28.5388C149.82 26.6664 151.304 25.1953 153.29 24.1254C155.276 23.0555 157.415 22.5206 159.708 22.5206C164.867 22.5206 168.368 24.5075 170.21 28.4815C173.445 24.5075 177.478 22.5206 182.309 22.5206C185.994 22.5206 188.973 23.5714 191.246 25.673C193.518 27.7746 194.654 30.8123 194.654 34.7863V53.4714H187.776V36.735C187.776 31.118 185.278 28.3095 180.283 28.3095C177.949 28.3095 175.912 29.0069 174.172 30.4016C172.431 31.7963 171.52 33.831 171.439 36.5057V53.4714H164.56V36.735C164.56 33.831 164.007 31.7007 162.902 30.3442C161.796 28.9878 160.056 28.3095 157.681 28.3095C155.306 28.3095 153.239 29.0451 151.478 30.5162C149.717 31.9873 148.837 34.1367 148.837 36.9643ZM208.013 53.4715V41.7216H215.628C221.934 41.7216 226.612 40.5944 229.662 38.34C232.713 36.0855 234.238 32.5319 234.238 27.6791C234.238 22.8263 232.743 19.2345 229.754 16.9036C226.765 14.5728 222.016 13.4073 215.506 13.4073H200.765V53.4715H208.013ZM208.013 35.5887H216.427C220.439 35.5887 223.172 34.8722 224.626 33.4393C226.08 32.0064 226.806 29.9048 226.806 27.1345C226.806 24.3642 225.885 22.4059 224.042 21.2596C222.2 20.1133 219.313 19.5401 215.383 19.5401H208.013V35.5887ZM246.061 53.9299C250.605 53.9299 254.229 52.4206 256.931 49.4019V53.4714H263.196V33.8119C263.196 29.9144 261.978 27.0581 259.542 25.2431C257.105 23.4281 253.963 22.5206 250.114 22.5206C245.078 22.5206 240.574 23.9917 236.602 26.9339L239.673 30.9461C242.949 28.8827 246.102 27.851 249.131 27.851C253.963 27.851 256.379 29.8762 256.379 33.9265V35.0728H247.473C243.42 35.0728 240.205 35.8179 237.831 37.3082C235.456 38.7984 234.268 41.0433 234.268 44.0428C234.268 47.0424 235.384 49.4401 237.616 51.2361C239.847 53.032 242.662 53.9299 246.061 53.9299ZM242.99 47.3099C244.218 48.0932 245.928 48.4849 248.118 48.4849C250.309 48.4849 252.223 47.9117 253.861 46.7654C255.498 45.6191 256.317 44.0715 256.317 42.1228V39.5435H248.579C243.624 39.5435 241.147 40.9955 241.147 43.8996C241.147 45.3898 241.761 46.5266 242.99 47.3099ZM280.147 53.93C283.075 53.93 285.746 52.9174 288.162 50.8923L285.337 46.3643C283.986 47.7016 282.573 48.3703 281.099 48.3703C279.625 48.3703 278.479 47.9405 277.66 47.0807C276.841 46.221 276.431 45.0651 276.431 43.6131V28.1376H285.03V22.9792H276.431V13.4073H269.553V22.9792H265.438V28.1376H269.553V43.4411C269.553 46.6508 270.587 49.2014 272.654 51.0929C274.722 52.9843 277.22 53.93 280.147 53.93Z"
      fill={textColor}
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Calendar Icon
 */
const Calendar: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.25 3.75H5.75C4.64543 3.75 3.75 4.64543 3.75 5.75V18.25C3.75 19.3546 4.64543 20.25 5.75 20.25H18.25C19.3546 20.25 20.25 19.3546 20.25 18.25V5.75C20.25 4.64543 19.3546 3.75 18.25 3.75Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M4 8.25H20"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M7.25 2V6"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M16.75 2V6"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Refresh Icon
 */
const Refresh: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.375 8.84C5.615 5.85 8.56 3.75 12 3.75C15.44 3.75 18.645 6.045 19.78 9.245"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M19.6251 15.16C18.3851 18.15 15.4401 20.25 12.0001 20.25C8.56012 20.25 5.39512 17.985 4.24512 14.82"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M20.25 3V8.75C20.25 9.025 20.025 9.25 19.75 9.25H14"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M3.75 21V15.25C3.75 14.975 3.975 14.75 4.25 14.75H10"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

/**
 *
 * @param param0 color and size
 * @returns Drag Icon
 */
const Drag: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="drag-indicator">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6.5C9.82843 6.5 10.5 5.82843 10.5 5C10.5 4.17157 9.82843 3.5 9 3.5C8.17157 3.5 7.5 4.17157 7.5 5C7.5 5.82843 8.17157 6.5 9 6.5ZM10.5 12C10.5 12.8284 9.82843 13.5 9 13.5C8.17157 13.5 7.5 12.8284 7.5 12C7.5 11.1716 8.17157 10.5 9 10.5C9.82843 10.5 10.5 11.1716 10.5 12ZM10.5 19C10.5 19.8284 9.82843 20.5 9 20.5C8.17157 20.5 7.5 19.8284 7.5 19C7.5 18.1716 8.17157 17.5 9 17.5C9.82843 17.5 10.5 18.1716 10.5 19ZM16.5 12C16.5 12.8284 15.8284 13.5 15 13.5C14.1716 13.5 13.5 12.8284 13.5 12C13.5 11.1716 14.1716 10.5 15 10.5C15.8284 10.5 16.5 11.1716 16.5 12ZM15 20.5C15.8284 20.5 16.5 19.8284 16.5 19C16.5 18.1716 15.8284 17.5 15 17.5C14.1716 17.5 13.5 18.1716 13.5 19C13.5 19.8284 14.1716 20.5 15 20.5ZM16.5 5C16.5 5.82843 15.8284 6.5 15 6.5C14.1716 6.5 13.5 5.82843 13.5 5C13.5 4.17157 14.1716 3.5 15 3.5C15.8284 3.5 16.5 4.17157 16.5 5Z"
        fill={color}
      />
    </g>
  </svg>
);

/**
 * A React functional component that renders an SVG icon representing an external link.
 *
 * @param {IconProps} props - The properties for the icon component.
 * @param {string} props.color - The color of the icon.
 * @param {number} props.size - The size of the icon.
 *
 * @returns {JSX.Element} The rendered SVG icon.
 */
const LinkExternal: React.FC<IconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75 4.5C5.05921 4.5 4.5 5.05921 4.5 5.75V18.25C4.5 18.9408 5.05921 19.5 5.75 19.5H18.25C18.9408 19.5 19.5 18.9408 19.5 18.25V12.5H21V18.25C21 19.7692 19.7692 21 18.25 21H5.75C4.23079 21 3 19.7692 3 18.25V5.75C3 4.23079 4.23079 3 5.75 3H11.5V4.5H5.75ZM18.4393 4.5H13.5V3H19.75C20.4392 3 21 3.56079 21 4.25V10.5H19.5V5.56066L11.2803 13.7803L10.2197 12.7197L18.4393 4.5Z"
      fill={color}
    />
  </svg>
);

/**
 * A React functional component that renders a warning icon.
 *
 * @param {IconProps} props - The properties for the icon component.
 * @param {string} props.color - The color of the icon.
 * @param {number} props.size - The size of the icon.
 *
 * @returns {JSX.Element} The rendered SVG icon.
 */
const ToastWarning: React.FC<IconProps> = ({ color, size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={color}
    height={size}
    width={size}
  >
    <path
      fillRule="evenodd"
      d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
      clipRule="evenodd"
    />
  </svg>
);

export {
  ArrowRight,
  ArrowLeft,
  ArrowCircleRight,
  ArrowCircleLeft,
  ExclamationCircle,
  Delete,
  Warning,
  ArrowBoxRight,
  Locked,
  Unlocked,
  DragIndicator,
  Checkmark,
  Undo,
  Plus,
  StarOutlined,
  StarFilled,
  Close,
  InfoCircle,
  QuestionCircle,
  PlusCircle,
  Edit,
  CircleCheck,
  Clip,
  Menu,
  Globe,
  User,
  WifiOff,
  ChevronLeft,
  ItemPathLogo,
  ItemPathText,
  ItemPathLogoWithText,
  Calendar,
  Refresh,
  Drag,
  LinkExternal,
  ToastWarning,
};
